import { clearAuthSession } from '@/auth/utils'

let isRedirectingToLogin = false

/**
 * On 401: clear session and go to login (never full-page reload — that caused infinite reload loops).
 */
export default function handleUnauthorized() {
  if (process.env.VUE_APP_E2E === 'true') return
  if (isRedirectingToLogin) return
  if (window.location.pathname === '/login') return

  isRedirectingToLogin = true
  clearAuthSession()
  window.location.assign('/login')
}
